import { filter, isArray } from 'lodash'
import { Icon } from '@iconify/react'
import { sentenceCase } from 'change-case'
import { useState, useEffect, useLayoutEffect, useRef } from 'react'
import plusFill from '@iconify/icons-eva/plus-fill'
import { Link as RouterLink, useLocation } from 'react-router-dom'
// material
import { useTheme } from '@material-ui/core/styles'
import {
  Box,
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  CircularProgress,
} from '@material-ui/core'
// redux
import { useDispatch, useSelector } from '../../redux/store'
import { getUserList, deleteUser } from '../../redux/slices/user'
// routes
import { PATH_DASHBOARD } from '../../routes/paths'
// components
import Page from '../../components/Page'
import Label from '../../components/Label'
import SearchNotFound from '../../components/SearchNotFound'
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs'
import {
  UserListHead,
  UserListToolbar,
  UserMoreMenu,
} from '../../components/_dashboard/user/list'
import UserRoleListToolbar from 'src/components/_dashboard/user/list/UserRoleListToolbar'
import ProductsSearch from 'src/components/_dashboard/blog/ProductsSearch.js'
import UserRoleView from 'src/components/_dashboard/user/list/UserRoleView.js'
import axios from 'axios'
import { COMPANY_NAME, REST_API_END_POINT } from 'src/constants/Defaultvalues'
import moment from 'moment';
import UserRoleViewData from 'src/components/_dashboard/user/list/UserRoleViewData'
import Modal from 'src/components/_dashboard/blog/ProjectModel'
import useTableMaxHeight from 'src/hooks/useTableMaxHeight'
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'authorized_by', label: 'Added By', alignRight: false },
  { id: 'addedOn', label: 'Added On', alignRight: false },
  { id: 'options', label: 'Options', alignRight: false },
]

// ----------------------------------------------------------------------

// function descendingComparator(a, b, orderBy) {
//   if (b[orderBy] < a[orderBy]) {
//     return -1
//   }
//   if (b[orderBy] > a[orderBy]) {
//     return 1
//   }
//   return 0
// }

function descendingComparator(a, b, orderBy) {
  const aValue = a[orderBy] ? a[orderBy].toString() : '';
  const bValue = b[orderBy] ? b[orderBy].toString() : '';
  return bValue.localeCompare(aValue, undefined, { sensitivity: 'base' });
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) return order
    return a[1] - b[1]
  })
  if (query) {
    return filter(array,(_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1)
  }
  return stabilizedThis.map((el) => el[0])
}

function scrollUserRoleListPaginationToTop(anchorEl, tableScrollBoxEl, tableContainerEl) {
  if (typeof window === 'undefined') return
  const { documentElement, body } = document
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  documentElement.scrollTop = 0
  body.scrollTop = 0

  let el = anchorEl
  while (el) {
    const { overflowY } = window.getComputedStyle(el)
    if (
      (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') &&
      el.scrollHeight > el.clientHeight
    ) {
      el.scrollTop = 0
    }
    el = el.parentElement
  }

  const scrollBox = tableScrollBoxEl
  if (scrollBox) {
    scrollBox.scrollTop = 0
    if (typeof scrollBox.scrollTo === 'function') {
      scrollBox.scrollTo({
        top: 0,
        left: scrollBox.scrollLeft,
        behavior: 'auto',
      })
    }
  }
  const tableWrap = tableContainerEl
  if (tableWrap) {
    const left = tableWrap.scrollLeft
    tableWrap.scrollTop = 0
    if (typeof tableWrap.scrollTo === 'function') {
      tableWrap.scrollTo({ top: 0, left, behavior: 'auto' })
    }
  }
}

export default function UserRoleList({isClientUserRoles}) {
  const theme = useTheme()
  const dispatch = useDispatch()
  const [userRoleList, setUserRoleList] = useState([])
  const [page, setPage] = useState(0)
  const [order, setOrder] = useState('asc')
  const [selected, setSelected] = useState([])
  const [selectedNames, setSelectedNames] = useState([])
  const [orderBy, setOrderBy] = useState('name')
  const [filterName, setFilterName] = useState('')
  const [rowsPerPage, setRowsPerPage] = useState(25)
  const [loading, setLoading] = useState(false)
  const [viewData, setViewData] = useState(null)
  const tableContainerRef = useRef(null)
  const tableScrollBoxRef = useRef(null)
  const paginationScrollAnchorRef = useRef(null)
  const skipPaginationScrollRef = useRef(true)
  const location = useLocation();
  let receivedData = location.state?.data;
  const user = JSON.parse(localStorage.getItem('user'))
  const userId = user.user_id
  const isClient = user.isClient
  const userType =isClient ?  3 : user.user_type

  const fetchAllUserRoles = async () => {
    setLoading(true)
    try {
      const response = await axios.post(`${REST_API_END_POINT}settings/get-all-settings`, {userId,userType,isClientUserRoles})
      // console.log("response fetch user roles",response.data);
      let data = response.data.results.user_roles;
      if(data){
        setUserRoleList(data)
      }
      else{
        setUserRoleList([])
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    dispatch(getUserList())
    fetchAllUserRoles()
  }, [dispatch,receivedData])

  const tableMaxHeight = useTableMaxHeight(
    tableScrollBoxRef,
    [loading, userRoleList.length, rowsPerPage]
  );

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
  }

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = userRoleList.map((n) => n.id)
      const newSelectedNames = userRoleList.map((n) => n.name)
      setSelected(newSelecteds)
      setSelectedNames(newSelectedNames)
      return
    }
    setSelected([])
    setSelectedNames([])
  }

  const handleClick = (event, id, name) => {
    const selectedIndex = selected.indexOf(id)
    const selectedNameIndex = selected.indexOf(name)
    let newSelected = []
    let newSelectedName = []
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id)
      newSelectedName = newSelectedName.concat(selectedNames, name)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1))
      newSelectedName = newSelectedName.concat(selectedNames.slice(1))
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1))
      newSelectedName = newSelectedName.concat(selectedNames.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex),selected.slice(selectedIndex + 1),)
      newSelectedName = newSelectedName.concat(selectedNames.slice(0, selectedNameIndex),selectedNames.slice(selectedNameIndex + 1),)
    }
    setSelected(newSelected)
    setSelectedNames(newSelectedName)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  useLayoutEffect(() => {
    if (skipPaginationScrollRef.current) {
      skipPaginationScrollRef.current = false
      return
    }
    const run = () =>
      scrollUserRoleListPaginationToTop(
        paginationScrollAnchorRef.current,
        tableScrollBoxRef.current,
        tableContainerRef.current
      )
    run()
    requestAnimationFrame(() => {
      requestAnimationFrame(run)
    })
  }, [page, rowsPerPage])

  const handleFilterByName = (event) => {
    setFilterName(event.target.value)
    setPage(0)
  }

  const handleDeleteUser = (userId) => {
    dispatch(deleteUser(userId))
  }

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - userRoleList.length) : 0

  const filteredUsers = applySortFilter(userRoleList,getComparator(order, orderBy),filterName)

  const isUserNotFound = filteredUsers.length === 0

  return (
    <Page title={`User Roles | ${COMPANY_NAME}`}>
      <Container>
        <Card>
          <UserRoleListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            selected={selected}
            selectedNames={selectedNames}
            onDelete={() => setSelected([])}
            userId={userId}
            isClientUserRoles={isClientUserRoles}
          />
          {loading ? (
            <CircularProgress color="primary" variant="indeterminate" />
          ) : (
            <>
            <Box ref={paginationScrollAnchorRef}>
            <Box
              ref={tableScrollBoxRef}
              sx={{
                maxHeight: tableMaxHeight,
                overflowY: 'auto',
                overflowX: 'hidden',
                width: '100%',
                '&::-webkit-scrollbar': {
                  width: '0.6em',
                  height: '0.6em',
                },
                '&::-webkit-scrollbar-track': {
                  background: '#1e1e1e',
                  borderRadius: '4px',
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: '#555',
                  borderRadius: '6px',
                  border: '2px solid #1e1e1e',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                  backgroundColor: '#888',
                },
                '&::-webkit-scrollbar-corner': {
                  backgroundColor: '#1e1e1e',
                },
              }}
            >
              <TableContainer
                ref={tableContainerRef}
                sx={{
                  minWidth: 800,
                  whiteSpace: 'nowrap',
                  overflowX: 'auto',
                  '&::-webkit-scrollbar': {
                    width: '0.6em',
                    height: '0.6em',
                  },
                  '&::-webkit-scrollbar-track': {
                    background: '#1e1e1e',
                    borderRadius: '4px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: '#555',
                    borderRadius: '6px',
                    border: '2px solid #1e1e1e',
                  },
                  '&::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: '#888',
                  },
                  '&::-webkit-scrollbar-corner': {
                    backgroundColor: '#1e1e1e',
                  },
                }}
              >
                <Table 
                  stickyHeader
                  sx={{
                    '& .MuiTableCell-head': {
                      padding: '8px 12px',
                      fontSize: '0.75rem',
                      fontWeight: 600,
                      height: '48px',
                      minHeight: '48px',
                      maxHeight: '48px',
                      lineHeight: 1.4,
                      whiteSpace: 'nowrap',
                      textAlign: 'left',
                      verticalAlign: 'middle'
                    },
                    '& .MuiTableSortLabel-root': {
                      fontSize: '0.75rem',
                      fontWeight: 600,
                      justifyContent: 'flex-start',
                      '& .MuiTableSortLabel-icon': {
                        marginLeft: '4px'
                      }
                    }
                  }}
                >
                  <UserListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={userRoleList.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                    showAllCheckBox
                  />
                  <TableBody>
                    {filteredUsers
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((row) => {
                        const { id, name, timestamp, status, authorized_by } = row
                        let statusText;
                        if (status === 1) {
                          statusText = "Active"
                        }else{
                          statusText = "Inactive"
                        }
                        const addedOn = moment.unix(timestamp).format('MM/DD/YYYY');
                        const isItemSelected = selected.indexOf(id) !== -1

                        return (
                          <TableRow
                            hover
                            key={id}
                            tabIndex={-1}
                            role="checkbox"
                            selected={isItemSelected}
                            aria-checked={isItemSelected}
                            sx={{
                              '& .MuiTableCell-root': {
                                padding: '8px 12px',
                                fontSize: '0.75rem',
                                height: 'auto',
                                lineHeight: 1.4
                              }
                            }}
                          >
                            <TableCell padding="checkbox">
                              <Checkbox
                                checked={isItemSelected}
                                onChange={(event) => handleClick(event,id, name)}
                              />
                            </TableCell>
                            <TableCell align="left" sx={{ fontSize: '0.75rem' }}>
                              <Label
                                variant={
                                  theme.palette.mode === 'light'
                                    ? 'ghost'
                                    : 'filled'
                                }
                                color={(status === 1 && 'info') || 'error'}
                              >
                                {sentenceCase(statusText)}
                              </Label>
                            </TableCell>
                            <TableCell align="left" sx={{ cursor: 'pointer', fontSize: '0.75rem' }}>
                              <Typography 
                                variant="subtitle2" 
                                noWrap 
                                sx={{
                                  cursor: 'pointer',
                                  fontWeight: 500,
                                  fontSize: '0.75rem'
                                }}
                                onClick={()=>setViewData(id)} >
                                  {name}
                              </Typography>
                            </TableCell>
                            <TableCell align="left" sx={{ fontSize: '0.75rem' }}>{authorized_by}</TableCell>
                            <TableCell align="left" sx={{ fontSize: '0.75rem' }}>{addedOn}</TableCell>
                            <TableCell align="left">
                              <UserRoleView
                                roleId={id}
                                status={status}
                                roleName={name}
                                userId={userId}
                                userType={userType}
                                isClientUserRoles={isClientUserRoles}
                              />
                            </TableCell>
                          </TableRow>
                        )
                      })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <SearchNotFound searchQuery={filterName} msg="User roles"/>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Box>

            <TablePagination
              rowsPerPageOptions={[25, 50, 100, 500]}
              component="div"
              count={filteredUsers?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
            </Box>
            </>
          )}
        </Card>
      </Container>
      <Modal
        modalTitle={'View User Role'}
        open={viewData ? true : false}
        handleClose={() => {
          setViewData(null)
        }}
      >
        <UserRoleViewData viewId={viewData} />
      </Modal>
    </Page>
  )
}
